import { IconBase, IconComponent } from './BaseIcon';

export const MoveTo: IconComponent = (props) => (
  <IconBase {...props}>
    <path d="M13 19v7H6V6h7v7h2V4H4v24h11v-9h-2zm4-15v6h2V6h7v20h-7v-4h-2v6h11V4H17zm.34 9.17L19.17 15H10v2h9.17l-1.83 1.83 1.42 1.41L23 16l-4.24-4.24-1.42 1.41z" />
  </IconBase>
);
